module.exports = __webpack_public_path__ + "img/grade4.a3726a80.png";